<template>
  <div>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="ruleTable"
      class="vxe-table-element"
      size="mini"
      align="center"
      :auto-resize="true"
      :data="productData"
      :toolbar="isEdit"
      :edit-rules="editRules"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-config="editConfig"
    >
      <template v-slot:buttons>
        <div style="padding-bottom: 10px">
          <vxe-button @click="handleAdd" type="primary" class="vxe-btn-save"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />{{ $t('xTable.insert') }}</vxe-button
          >
          <vxe-button @click="handleDelete" type="primary" class="vxe-btn-delete"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-white-delete"
            />{{ $t('xTable.delete') }}</vxe-button
          >
        </div>
      </template>
      <vxe-table-column v-if="isEdit" fixed="left" type="checkbox" width="60"></vxe-table-column>
      <template v-for="(item, index) in columns">
        <vxe-table-column
          :key="index"
          :field="item.field"
          :width="item.width || 120"
          :title="item.title"
          :fixed="item.fixed"
          :edit-render="item.editRender"
        >
          <template v-slot:edit="{ row }">
            <search-table
              v-if="item.editRender && item.editRender.name == 'searchTable'"
              v-model="row[item.field]"
              :searchType="item.searchType"
              :isMultiple="true"
              :currentValue="row[item.checkValue] ? row[item.checkValue] : ''"
              :checkRowKeys="row[item.checkCode] ? [row[item.checkCode]] : []"
              :extraData="item.field == 'saleBatchNo' ? batchMoreData : undefined"
              @input="() => chooseTable(row, item.field)"
            ></search-table>
            <!--如果是数字输入-->
            <template v-if="item.editRender && item.editRender.name == 'inputNumber'">
              <input-number-ad
                v-model="row[item.field]"
                :max="item.max"
                :precision="item.precision || 6"
                :disabled="item.disabled || false"
                @change="() => handleChangeNumbxer(row)"
                @focus="() => handleFocusNumber(row, item.field)"
              ></input-number-ad>
            </template>
            <!--输入框-->
            <template v-if="item.editRender && item.editRender.name == 'ElInput'">
              <el-input v-model="row[item.field]" :disabled="item.disabled || false"></el-input>
            </template>
            <template v-if="item.editRender && item.editRender.name == 'ajaxSelect'">
              <ajax-select
                v-model="row[item.field]"
                :apiUrl="item.apiUrl"
                :apiData="item.apiData"
                :valueType="item.valueType"
                @change="(val) => chooseTable(row, item.field, val)"
                :valueKey="item.valueKey"
                :labelKey="item.labelKey"
                :disabled="item.disabled || false"
              ></ajax-select>
            </template>
          </template>
          <template v-slot="{ row }">
            <template v-if="item.editRender && item.editRender.name == 'searchTable'">{{
              row[item.checkValue]
            }}</template>
            <template v-else-if="item.editRender && item.editRender.name == 'ajaxSelect'">
              {{
                item.dictType
                  ? $baseRequest.getDictValueByType(item.dictType, row[item.field])
                  : row[item.name]
              }}</template
            >
            <template
              v-else-if="
                item.editRender &&
                (item.editRender.name == 'inputNumber' || item.editRender.name == 'ElInput') &&
                item.showlimit
              "
              >{{ $baseRequest.formatTableColumn(row[item.field], item.showlimit) }}</template
            >
            <template v-else>
              {{ row[item.field] }}
            </template>
          </template>
        </vxe-table-column>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import searchTable from '@/components/form-item/search-table';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import { spliceMoreZero, toFixedNumber } from '@/common/js/util';
  import API from '@/api/departmentBusiness/index';
  import BASE_API from '@/api/dataBase';
  import ajaxSelect from '@/components/form-item/ajax-select';

  export default {
    props: {
      isEdit: {
        type: Boolean,
        default: true,
      },
      defaultData: {
        type: Array,
        default: () => [],
      },
      // 仓库编码：卖出仓库下的业务批次
      saleStorageCode: {
        type: String,
        default: '',
      },
      //卖出部门
      saleDepartmentCode: {
        type: String,
        default: '',
      },
    },
    components: {
      searchTable,
      inputNumberAd,
      ajaxSelect,
    },
    data() {
      return {
        productData: [], // 商品表格
        tableToolbar: {},
        editConfig: {},
        tradeDetailDelIds: [], // 删除的id
        addedTaxRateOptions: [], //税码
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      batchMoreData() {
        // 批次查询：指定仓库、状态下的
        return {
          storageNo: this.saleStorageCode,
          inboundStatus: '02',
          batchDepartmentNo: this.saleDepartmentCode,
        };
      },
      columns() {
        return [
          {
            field: 'productNo',
            title: this.$t('departmentBusinessAdd.productTable.productNo'),
            editRender: { name: 'ElInput' },
            fixed: 'left',
            disabled: true,
          },
          {
            field: 'productDesc',
            title: this.$t('departmentBusinessAdd.productTable.productName'),
            editRender: { name: 'ElInput' },
            fixed: 'left',
            disabled: true,
          },
          {
            field: 'supplierName',
            title: this.$t('departmentBusiness.supplierName'),
            editRender: { name: 'ElInput' },
            disabled: true,
          },
          {
            field: 'saleBatchNo',
            title: this.$t('departmentBusinessAdd.productTable.sellLot'),
            editRender: { name: 'searchTable' },
            checkValue: 'saleBatchNo',
            checkCode: 'saleBatchNo',
            searchType: 'warehouseBatch',
            required: true,
          },
          {
            field: 'buyBatchNo',
            title: this.$t('departmentBusinessAdd.productTable.buyBatch'),
            editRender: { name: 'ElInput' },
            disabled: true,
          },
          {
            field: 'tradeUnitName',
            title: this.$t('departmentBusinessAdd.productTable.unit'),
            editRender: { name: 'ElInput' },
            disabled: true,
          },
          {
            field: 'tradeQuantity',
            title: this.$t('departmentBusinessAdd.productTable.businessNumber'),
            editRender: { name: 'inputNumber' },
            max: 999999999.999999,
            required: true,
            precision: this.$globalVar.qPoint,
            showlimit: this.$globalVar.qPoint,
          },
          {
            field: 'businessTradePrice',
            title: this.$t('departmentBusinessAdd.productTable.businessPrice'),
            editRender: { name: 'inputNumber' },
            width: 140,
            required: true,
            max: '99999999999.999999',
            precision: this.$globalVar.aPoint,
            showlimit: this.$globalVar.aPoint,
          },
          {
            field: 'businessTradeAmount',
            title: this.$t('departmentBusinessAdd.productTable.businessAmount'),
            editRender: { name: 'ElInput' },
            showlimit: this.$globalVar.aPoint,
            disabled: true,
          },
          {
            field: 'businessTradeAvgPrice',
            title: this.$t('departmentBusinessAdd.productTable.businessTradeAvgPrice'),
            editRender: { name: 'ElInput' },
            disabled: true,
            showlimit: this.$globalVar.aPoint,
          },
          {
            field: 'businessTradeAvgAmount',
            title: this.$t('departmentBusinessAdd.productTable.businessTradeAvgAmount'),
            editRender: { name: 'ElInput' },
            disabled: true,
            showlimit: this.$globalVar.aPoint,
          },
          {
            field: 'taxAmount',
            title: this.$t('departmentBusinessAdd.productTable.financeInputTaxAmount'),
            editRender: { name: 'ElInput' },
            max: 999999999.999999,
            disabled: true,
            showlimit: this.$globalVar.aPoint,
          },
          {
            field: 'taxCode',
            title: this.$t('departmentBusinessAdd.productTable.taxCode'),
            editRender: { name: 'ajaxSelect', type: 'default' },
            apiUrl: BASE_API.QUERY_TAX_RATE,
            valueKey: 'taxCode',
            labelKey: 'taxName',
            valueType: 'object',
            dictType: 'tax_rate',
            name: 'taxName',
            required: true,
          },
          {
            field: 'taxRate',
            title: this.$t('departmentBusinessAdd.productTable.taxRate'),
            editRender: { name: 'ElInput' },
            disabled: true,
            showlimit: this.$globalVar.tPoint,
          },
          {
            field: 'tradeAmountWithoutTax',
            title: this.$t('departmentBusinessAdd.productTable.tradeAmountWithoutTax'),
            editRender: { name: 'ElInput' },
            disabled: true,
            showlimit: this.$globalVar.aPoint,
          },
        ];
      },
      editRules() {
        return this.getRules();
      },
    },
    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.$baseRequest.getTaxRate({}).then((result) => {
        this.addedTaxRateOptions = result;
      });
    },
    watch: {
      // 判断表格编辑功能是否禁用
      isEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
      defaultData() {
        this.setData();
      },
    },
    methods: {
      spliceMoreZero,
      toFixedNumber,
      setData() {
        this.productData = this.defaultData.slice();
        this.productData.forEach((item) => {
          if (item.taxCode) {
            item.taxName = this.addedTaxRateOptions.find((options) => {
              return item.taxCode == options.taxCode;
            })?.taxName;
          }
        });
      },
      // 选择入库批次
      chooseTable(row, field, val) {
        if (field === 'saleBatchNo') {
          // 检查批次是否存在
          const tableData = this.getValues();
          const saleBatch = row.saleBatchNo ? row.saleBatchNo[0] || {} : {};
          const hasFlag = tableData.some((item) => {
            if (item.saleBatchNo == saleBatch.batchNo) {
              return true;
            }
          });
          if (hasFlag) {
            this.$alert('该批次已存在');
            row.saleBatchNo = '';
            return;
          }
          row.saleBatchNo = saleBatch.batchNo;
          row.productDesc = saleBatch.productName;
          row.productNo = saleBatch.productDetailNo;
          row.tradeUnit = saleBatch.productUnit;
          row.tradeUnitName = saleBatch.productUnitName;
          row.financeTradeAvgPrice = saleBatch.businessUnitPriceWithTax;
          row.businessTradeAvgPrice = saleBatch.businessUnitPriceWithTax;
          row.supplierName = saleBatch.partnerName;
          row.supplierNo = saleBatch.partnerNo;
          row.tradeQuantity = saleBatch.storageQuantity;
          row.businessTradeAmount = row.businessTradePrice * row.tradeQuantity;

          let params = { batchNo: saleBatch.batchNo };
          this.$axios.post(API.GET_CONTRACT, params).then((res) => {
            if (res.data.code == 0) {
              row.taxCode = res.data.data.taxCode || null;
              row.taxRate = res.data.data.taxRate || null;
              if (row.taxCode) {
                row.taxName = this.addedTaxRateOptions.find((options) => {
                  return row.taxCode == options.taxCode;
                })?.taxName;
              }
              this.handleChangeNumbxer(row);
            }
          });
        }
        //税码
        if (field === 'taxCode') {
          row.taxCode = val.taxCode ? val.taxCode : null;
          row.taxName = val.taxCode ? val.taxName : null;
          row.taxRate = val.taxCode ? val.taxRate : null;
          this.handleChangeNumbxer(row);
        }
      },
      handleAdd() {
        if (!this.saleDepartmentCode) {
          this.$message({
            showClose: true,
            message: this.$t('departmentBusinessAdd.storageDepartTip'),
            type: 'error',
          });
          return;
        }
        if (!this.saleStorageCode) {
          this.$message({
            showClose: true,
            message: this.$t('departmentBusinessAdd.storageEmptyTip'),
            type: 'error',
          });
          return;
        }
        this.$refs.ruleTable.commitProxy('insert_actived');
      },
      //获取库存数量
      handleFocusNumber(row, field) {
        if (field == 'tradeQuantity' && row.saleBatchNo && !row.maxtradeQuantity) {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            companyCode: this.userInfo.userInfo.companyCode,
            batchDepartmentNo: this.saleDepartmentCode,
            inboundStatus: '02',
            inboundType: '0',
            productName: null,
            startGmtCreate: null,
            endGmtCreate: null,
            contractInternalNo: null,
            batchNo: row.saleBatchNo,
            storageName: null,
            partnerName: null,
            marineLadingNo: null,
            warehouseReceiptsNo: null,
            settleBatchNo: null,
            productDetailNo: null,
            storageNo: this.saleStorageCode,
            pageSize: 10,
            pageNum: 1,
          };
          this.$axios.post(API.LIST_INBOUND, params).then((res) => {
            if (res.data.code == 0) {
              row.maxtradeQuantity = res.data.data.list[0].storageQuantity;
            } else {
              row.maxtradeQuantity = 0;
            }
          });
        }
      },
      handleChangeNumbxer(row) {
        // TODO 提供接口计算
        if (row.maxtradeQuantity && row.maxtradeQuantity < row.tradeQuantity) {
          row.tradeQuantity = row.maxtradeQuantity;
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('departmentBusinessAdd.message.maxtradeQuantity'),
          });
        }
        if (row.tradeQuantity && row.businessTradePrice) {
          row.businessTradeAmount = this.$cal.calCommon(
            row.tradeQuantity,
            row.businessTradePrice,
            '*',
            'amount'
          );
          //不含税金额字段=交易金额/(1+税率)
          let step1 = this.$cal.calCommon(1, row.taxRate, '+');
          row.tradeAmountWithoutTax = this.$cal.calCommon(
            row.businessTradeAmount,
            step1,
            '/',
            'amount'
          );
          console.log(row.tradeAmountWithoutTax);
          row.taxAmount = this.$cal.calCommon(
            row.businessTradeAmount,
            row.tradeAmountWithoutTax,
            '-',
            'amount'
          );
          // 成本金额（含税）
          row.businessTradeAvgAmount = this.$cal.calCommon(
            row.tradeQuantity,
            row.businessTradeAvgPrice || 0,
            '*',
            'amount'
          );
          this.$refs.ruleTable.updateData();
        }
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.tableData;
        // 取有批次号的数据
        return tableData.filter((item) => {
          return item.saleBatchNo;
        });
      },
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            const tradeDetailDelIds = selectedList.map((item) => {
              return item.id;
            });
            // 删除的id
            this.tradeDetailDelIds = this.tradeDetailDelIds.concat(tradeDetailDelIds);
            this.$refs['ruleTable'].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
          })
          .catch(() => {
            this.$message({ showClose: true, type: 'info', message: this.$t('message.cancle') });
          });
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columns.forEach((item) => {
          if (item.required) {
            const message = item.title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });
        return rules;
      },
    },
  };
</script>
